import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { catalogueData } from '../data/mockData';
import { Euro, CheckCircle2 } from 'lucide-react';

const CataloguePage = () => {
  const [activeTab, setActiveTab] = useState('poseSol');

  return (
    <section className="py-20 bg-white min-h-screen pt-32">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-[#F5EFE6] rounded-full mb-4">
            <span className="text-[#8B7355] font-semibold text-sm">Catalogue & Tarifs</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos prestations et tarifs
          </h2>
          <p className="text-lg text-gray-600">
            Découvrez notre gamme complète de services avec des tarifs transparents
          </p>
        </div>

        {/* Catalogue Tabs */}
        <div className="max-w-6xl mx-auto">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="grid w-full grid-cols-2 lg:grid-cols-5 h-auto gap-2 bg-[#F5EFE6] p-2 rounded-xl mb-8">
              <TabsTrigger 
                value="poseSol" 
                className="data-[state=active]:bg-[#8B7355] data-[state=active]:text-white py-3 rounded-lg font-medium transition-all"
              >
                Pose de sol
              </TabsTrigger>
              <TabsTrigger 
                value="preparation" 
                className="data-[state=active]:bg-[#8B7355] data-[state=active]:text-white py-3 rounded-lg font-medium transition-all"
              >
                Préparation
              </TabsTrigger>
              <TabsTrigger 
                value="escaliers" 
                className="data-[state=active]:bg-[#8B7355] data-[state=active]:text-white py-3 rounded-lg font-medium transition-all"
              >
                Escaliers
              </TabsTrigger>
              <TabsTrigger 
                value="mural" 
                className="data-[state=active]:bg-[#8B7355] data-[state=active]:text-white py-3 rounded-lg font-medium transition-all"
              >
                Murs
              </TabsTrigger>
              <TabsTrigger 
                value="portes" 
                className="data-[state=active]:bg-[#8B7355] data-[state=active]:text-white py-3 rounded-lg font-medium transition-all"
              >
                Portes
              </TabsTrigger>
            </TabsList>

            {/* Pose de Sol */}
            <TabsContent value="poseSol" className="mt-8">
              <Card className="border-0 shadow-xl">
                <CardHeader className="bg-gradient-to-r from-[#F5EFE6] to-[#F5EFE6]/50 border-b border-[#C9A961]/20">
                  <CardTitle className="text-2xl text-gray-900">{catalogueData.poseSol.title}</CardTitle>
                </CardHeader>
                <CardContent className="p-6">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {catalogueData.poseSol.items.map((item, index) => (
                      <div 
                        key={index}
                        className="group relative overflow-hidden rounded-xl border border-gray-200 hover:border-[#8B7355] transition-all duration-300 hover:shadow-lg"
                      >
                        {item.image && (
                          <div className="h-40 overflow-hidden">
                            <img 
                              src={item.image} 
                              alt={item.name}
                              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                            />
                          </div>
                        )}
                        <div className="p-4 bg-white">
                          <h4 className="font-semibold text-gray-900 mb-2">{item.name}</h4>
                          <div className="flex items-center justify-between">
                            <span className="text-2xl font-bold text-[#8B7355]">{item.price}</span>
                            <CheckCircle2 className="w-5 h-5 text-[#C9A961]" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Préparation */}
            <TabsContent value="preparation" className="mt-8">
              <Card className="border-0 shadow-xl">
                <CardHeader className="bg-gradient-to-r from-[#F5EFE6] to-[#F5EFE6]/50 border-b border-[#C9A961]/20">
                  <CardTitle className="text-2xl text-gray-900">{catalogueData.preparation.title}</CardTitle>
                </CardHeader>
                <CardContent className="p-6">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {catalogueData.preparation.items.map((item, index) => (
                      <div 
                        key={index}
                        className="group relative overflow-hidden rounded-xl border border-gray-200 hover:border-[#8B7355] transition-all duration-300 hover:shadow-lg"
                      >
                        {item.image && (
                          <div className="h-40 overflow-hidden">
                            <img 
                              src={item.image} 
                              alt={item.name}
                              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                            />
                          </div>
                        )}
                        <div className="p-4 bg-white">
                          <h4 className="font-semibold text-gray-900 mb-2">{item.name}</h4>
                          <div className="flex items-center justify-between">
                            <span className="text-2xl font-bold text-[#8B7355]">{item.price}</span>
                            <CheckCircle2 className="w-5 h-5 text-[#C9A961]" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Escaliers */}
            <TabsContent value="escaliers" className="mt-8">
              <Card className="border-0 shadow-xl">
                <CardHeader className="bg-gradient-to-r from-[#F5EFE6] to-[#F5EFE6]/50 border-b border-[#C9A961]/20">
                  <CardTitle className="text-2xl text-gray-900">{catalogueData.escaliers.title}</CardTitle>
                </CardHeader>
                <CardContent className="p-6">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {catalogueData.escaliers.items.map((item, index) => (
                      <div 
                        key={index}
                        className="group relative overflow-hidden rounded-xl border border-gray-200 hover:border-[#8B7355] transition-all duration-300 hover:shadow-lg"
                      >
                        {item.image && (
                          <div className="h-40 overflow-hidden">
                            <img 
                              src={item.image} 
                              alt={item.name}
                              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                            />
                          </div>
                        )}
                        <div className="p-4 bg-white">
                          <h4 className="font-semibold text-gray-900 mb-2">{item.name}</h4>
                          <div className="flex items-center justify-between">
                            <span className="text-2xl font-bold text-[#8B7355]">{item.price}</span>
                            <CheckCircle2 className="w-5 h-5 text-[#C9A961]" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Mural */}
            <TabsContent value="mural" className="mt-8">
              <Card className="border-0 shadow-xl">
                <CardHeader className="bg-gradient-to-r from-[#F5EFE6] to-[#F5EFE6]/50 border-b border-[#C9A961]/20">
                  <CardTitle className="text-2xl text-gray-900">{catalogueData.mural.title}</CardTitle>
                </CardHeader>
                <CardContent className="p-6">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {catalogueData.mural.items.map((item, index) => (
                      <div 
                        key={index}
                        className="group relative overflow-hidden rounded-xl border border-gray-200 hover:border-[#8B7355] transition-all duration-300 hover:shadow-lg"
                      >
                        {item.image && (
                          <div className="h-40 overflow-hidden">
                            <img 
                              src={item.image} 
                              alt={item.name}
                              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                            />
                          </div>
                        )}
                        <div className="p-4 bg-white">
                          <h4 className="font-semibold text-gray-900 mb-2">{item.name}</h4>
                          <div className="flex items-center justify-between">
                            <span className="text-2xl font-bold text-[#8B7355]">{item.price}</span>
                            <CheckCircle2 className="w-5 h-5 text-[#C9A961]" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Portes */}
            <TabsContent value="portes" className="mt-8">
              <Card className="border-0 shadow-xl">
                <CardHeader className="bg-gradient-to-r from-[#F5EFE6] to-[#F5EFE6]/50 border-b border-[#C9A961]/20">
                  <CardTitle className="text-2xl text-gray-900">{catalogueData.portes.title}</CardTitle>
                </CardHeader>
                <CardContent className="p-6">
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {catalogueData.portes.items.map((item, index) => (
                      <div 
                        key={index}
                        className="group relative overflow-hidden rounded-xl border border-gray-200 hover:border-[#8B7355] transition-all duration-300 hover:shadow-lg"
                      >
                        {item.image && (
                          <div className="h-40 overflow-hidden">
                            <img 
                              src={item.image} 
                              alt={item.name}
                              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                            />
                          </div>
                        )}
                        <div className="p-4 bg-white">
                          <h4 className="font-semibold text-gray-900 mb-2">{item.name}</h4>
                          <div className="flex items-center justify-between">
                            <span className="text-2xl font-bold text-[#8B7355]">{item.price}</span>
                            <CheckCircle2 className="w-5 h-5 text-[#C9A961]" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </div>

        {/* Bottom Note */}
        <div className="text-center mt-12 p-6 bg-[#F5EFE6] rounded-xl max-w-3xl mx-auto">
          <p className="text-gray-700">
            Tous nos tarifs sont indicatifs. 
            Contactez-nous pour une estimation précise adaptée à votre projet.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CataloguePage;
